import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

//import { BusinessLogListPage } from '../business-log-list/business-log-list';
import { BusinessMessageManagerPage } from '../business-message-manager/business-message-manager';
import { BusinessMessageLogListPage } from '../business-message-log-list/business-message-log-list';


@Component({
  selector: 'page-business-messaging-main',
  templateUrl: 'business-messaging-main.html',
})
export class BusinessMessagingMainPage {
	message = BusinessMessageManagerPage;
	log = BusinessMessageLogListPage;
	
	constructor(public navCtrl: NavController, public navParams: NavParams) {
	}

	ionViewDidLoad() {
		console.log('ionViewDidLoad BusinessMessagingMainPage');
	}
}



// WEBPACK FOOTER //
// ./src/pages/business-messaging-main/business-messaging-main.ts